exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-connect-promo-info{line-height:20px}.home-connect-promo-info p{margin-bottom:15px}.home-connect-promo-info img{float:right;height:100px;margin:0 15px}@media (max-width: 639px){.home-connect-promo-info img{display:block;float:unset;margin:0 auto;padding-bottom:15px}}\n", ""]);

// exports
exports.locals = {
	"home-connect-promo-info": "home-connect-promo-info"
};